<div class="grid-container margin-top">
  <form #newDashboard="ngForm" (ngSubmit)="create()">
    <div>
      <label for="dashboardName">Name:</label>
      <input #title="ngModel" id="dashboardName" name="title" type="text" [(ngModel)]="dashboard.title" required>

      @if (title.errors && (title.dirty || title.touched || formSubmitted)) {
        <div class="error-container">
          @if (title.errors.required) {
            <small class="error">Name is required</small>
          }
        </div>
      }
    </div>

    <fieldset class="inline-label-input-group">
      <legend class="float-left">Select Type:</legend>
      @for (l of layoutOptions; track l) {
        <label>
          <input name="selectedLayout" [(ngModel)]="selectedLayout" type="radio" [value]="l.value" required>
          {{l.name}}
        </label>
      }

      @if (layoutInvalid) {
        <small class="error no-margin-top">Type is required</small>
      }
    </fieldset>

    @if (selectedLayout == dashboardTypes.Column) {
      <div>
        <fieldset>
          <legend>Choose your layout type:</legend>
          <div class="layout-options">
            @for (layout of layoutKind; track layout) {
              <label>
                <input type="radio" name="selectedLayoutType" [(ngModel)]="selectedLayoutType" [value]="layout.value" [required]="selectedLayout == dashboardTypes.Column">
                @if (layout.value !== selectedLayoutType) {
                  <svg-icon icon="{{layout.icon}}"></svg-icon>
                }
                @if (layout.value === selectedLayoutType) {
                  <svg-icon icon='{{layout.icon}}-selected'></svg-icon>
                }
              </label>
            }
          </div>
        </fieldset>
        @if (form.controls.selectedLayoutType?.errors && formSubmitted) {
          <div>
            @if (form.controls.selectedLayoutType?.errors.required) {
              <small class="error margin-top-0">Layout type is required</small>
            }
          </div>
        }
      </div>
    }

    @if (selectedLayout == dashboardTypes.Single) {
      <div>
        <label>Choose your view:</label>
        <select #widgetType="ngModel" name="widgetType" [(ngModel)]="selectedWidgetType" [required]="selectedLayout == dashboardTypes.Single">
          @for (option of types; track option) {
            <option>{{option}}</option>
          }
        </select>
        @if (widgetType.errors && (widgetType.dirty || widgetType.touched || formSubmitted)) {
          <div class="error-container">
            @if (widgetType.errors.required) {
              <small class="error">View is required</small>
            }
          </div>
        }
      </div>
    }

    @if (selectedLayout == dashboardTypes.Copy) {
      <div>
        <label>Select View to Copy:</label>
        <select #copy="ngModel" name="copyExistingID" [(ngModel)]="copyExistingID" [required]="selectedLayout == dashboardTypes.Copy">
          @for (d of dashboards; track d) {
            <option [value]="d.id">{{d.title}}</option>
          }
        </select>
        @if (copy.errors && (copy.dirty || copy.touched || formSubmitted)) {
          <div class="error-container">
            @if (copy.errors.required) {
              <small class="error">Page is required</small>
            }
          </div>
        }
      </div>
    }
  </form>
</div>
